import type { Branding as BrandingType, ParsedBranding } from '../@types/branding';

class Branding {
  static parse = ({
    baseDuration365,
    category,
    conversionUrl,
    createdAt,
    creditCheckApiIdentifier,
    defaultPaybackTime,
    description,
    environment,
    hasConversionParameterSupport,
    id,
    identifier,
    institute,
    logo,
    featuredImage,
    manufacturerFilter,
    name,
    residualMatrix,
    slug,
    telephone,
    termsUrl,
    updatedAt,
    website,
    uspTitle,
    uspList,
  }: BrandingType): ParsedBranding => {
    const logoUrl = logo && logo.file && logo.file.url ? logo.file.url : null;

    const featuredImageUrl =
      featuredImage && featuredImage.file && featuredImage.file.url ? featuredImage.file.url : null;

    return {
      baseDuration365,
      category,
      conversionUrl,
      createdAt,
      creditCheckApiIdentifier,
      defaultPaybackTime,
      description,
      environment,
      hasConversionParameterSupport,
      id,
      identifier,
      institute,
      logo: logoUrl,
      featuredImage: featuredImageUrl,
      manufacturerFilter,
      name,
      residualMatrix,
      slug,
      telephone,
      termsUrl,
      updatedAt,
      website,
      uspTitle,
      uspList,
    };
  };
}

export default Branding;
